export enum WorkingHoursEnum {
  '0_30' = '0-30',
  '30_50' = '30-50',
  '50_100' = '50-100',
  'OVER_100' = '100+',
}

export const WorkingHours = [
  {
    label: '0-30',
    value: '0-30',
  },
  {
    label: '30-50',
    value: '30-50',
  },
  {
    label: '50-100',
    value: '50-100',
  },
  {
    label: '100+',
    value: '100+',
  },
];
